<script>
import { API } from '@/net/http';
import { mapState } from 'vuex';
import MkLink from '@/components/button/MkLink.vue';
import BillProcessDialog from '@/components/home/BillProcessDialog.vue';

export default {
  name: 'BillList',
  components: { BillProcessDialog, MkLink },
  data() {
    return {
      loadingPayment: true,
      bills: [],
      showBillProcessDialog: false,
    };
  },
  computed: {
    ...mapState('send', ['sendInfo']),
  },
  mounted() {
    this.initPayment(this.sendInfo.orderNum);
  },
  methods: {
    initPayment(orderNum) {
      this.loadingPayment = true;
      this.$post(API.orderStatusBill, {
        orderNum: orderNum,
      })
        .then(res => {
          // console.log('res', res);
          this.loadingPayment = false;
          if (res.success) {
            this.bills = res.data ? res.data : [];
            //排序包裹
            for (let bill of this.bills) {
              for (let d of bill.billDetailVo2s) {
                d.packages.sort((a, b) => a.boxNum - b.boxNum);
              }
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(() => {
          this.loadingPayment = false;
        });
    },
    //通过账单名判断包裹是否显示计费重或费用
    showFee(billName) {
      return (
        (!this.isShippingFee(billName) && billName.startsWith('Storage')) ||
        billName === 'Shipping insurance' ||
        billName.includes('Signature')
      );
    },
    showWeight(billName) {
      return this.isShippingFee(billName) && !billName.startsWith('Storage');
    },
    isShippingFee(billName) {
      return billName === 'Shipping' || billName === 'Return shipping' || billName === 'Pre-payment';
    },
    changeDetail(index) {
      let bill = this.bills[index];
      bill.show = !bill.show;
      this.$set(this.bills, index, bill);
    },
    getBillPayDetail(bill) {
      this.$post(API.paymentDetails, {
        id: bill.billId,
      }).then(res => {
        if (res.success) {
          this.$set(bill, 'stripeId', res.data.stripeId);
          this.$set(bill, 'cardNumber', res.data.cardNumber);
          this.$set(bill, 'type', res.data.type);
          this.$set(bill, 'date', res.data.date);
        } else {
          this.$Message.error({
            duration: 3,
            content: res.message,
          });
        }
      });
    },
  },
};
</script>

<template>
  <div v-if="bills.length > 0" class="payment-info">
    <div style="display: flex; justify-content: space-between">
      <p class="title">Billing information</p>
      <MkLink class="title-link" @click="showBillProcessDialog = true">About billing process ></MkLink>
      <BillProcessDialog v-model="showBillProcessDialog" :footer-hide="true" />
    </div>
    <div v-if="!loadingPayment" class="payment-box">
      <div class="payment-wrap">
        <div v-for="(bill, index) in bills" :key="bill.billId" class="payment-item">
          <div class="payment-row">
            <span class="title">
              <span style="margin-right: 15px">${{ bill.fee }}</span>
              <i-tag color="#37C3BA" class="tag">Succeeded<i-icon class="d-cion" type="md-checkmark" /></i-tag>
              <i-tag v-if="bill.billType === 'SEND_PREPAYMENT'" color="#6e6def" class="tag">Pre-payment</i-tag>
              <i-tag v-if="Number(bill.fee) < 0" color="#6e6def" class="tag">Refund</i-tag>
            </span>
            <i-poptip class="time" transfer placement="right" @on-popper-show="getBillPayDetail(bill)">
              <span class="btn0 detail">Method</span>
              <div slot="content">
                <div class="pop-detail-item">
                  <b style="margin-right: 20px">ID</b>
                  <span>{{ bill.stripeId }}</span>
                </div>
                <div class="pop-detail-item">
                  <b>Card</b>
                  <span>{{ bill.type === 'Link' ? '' : '•••• ' }} {{ bill.cardNumber }}</span>
                </div>
                <div class="pop-detail-item">
                  <b>Type</b>
                  <span>{{ bill.type }}</span>
                </div>
                <div class="pop-detail-item">
                  <b>Date</b>
                  <span>{{ bill.date }}</span>
                </div>
              </div>
            </i-poptip>
          </div>
          <div class="detail payment-row">
            <span class="btn detail" @click="changeDetail(index)">Details</span>
          </div>
          <div v-show="bill.show" class="info-list">
            <div v-for="detail in bill.billDetailVo2s" :key="detail.billName" class="info-item">
              <div class="info">
                <span class="title">{{ detail.billName }}</span>
                <span class="price">${{ detail.billFee }}</span>
              </div>
              <div class="info">
                <i-poptip v-if="detail.packages && detail.packages.length > 0" transfer placement="bottom">
                  <span class="btn detail">{{ detail.packages.length }} packages</span>
                  <div slot="content">
                    <div v-for="pak in detail.packages" :key="pak.trkNum" class="pop-box-item">
                      <div class="row">
                        <span class="num">#{{ pak.boxNum }}</span>
                        <div class="content">
                          <div class="content-row">
                            <span class="tip">Tracking #</span>
                            <div class="number">
                              <span>{{ pak.trkNum }}</span>
                            </div>
                          </div>
                          <div class="content-row info">
                            <span v-if="showFee(detail.billName)" class="weight">${{ pak.fee }}</span>
                            <span v-if="showWeight(detail.billName)" class="tip tip-right">Rated weight</span>
                            <span v-if="showWeight(detail.billName)" class="weight">{{ pak.weightPay }}LB</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </i-poptip>
                <span v-else class="desc">{{ detail.billInfo }}</span>
                <span
                  v-if="detail.description"
                  class="desc"
                  :class="{ 'shipping-fee': isShippingFee(detail.billName) }"
                >
                  {{ detail.description }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="payment-login">
      <i-spin fix>
        <i-icon type="ios-loading" size="40" class="spin-icon-load" />
      </i-spin>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import '~@/assets/css/main.less';
@import '~@/assets/fonts/font.less';
.title {
  .font-regular;
  font-size: 16px;
  font-weight: 400;
  color: #262626;
  line-height: 19px;
}
.title-link {
  color: @app-blue-color;
}
.payment-info {
  margin-top: 36px;
  position: relative;
  min-height: 100px;
  .payment-box {
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #eeeff0;
    padding: 34px 0 0;
    .payment-wrap {
      padding: 0 24px;
      .payment-login {
        height: 100px;
      }
      .payment-item {
        position: relative;
        border-left: 1px dashed @app-color;
        padding-left: 22px;
        padding-bottom: 25px;
        &:first-child {
          margin-top: 0;
        }
        &:last-child {
          border-left: 0 dashed @app-color;
        }
        &:before {
          content: ' ';
          display: inline-block;
          position: absolute;
          width: 6px;
          left: -3px;
          top: 6px;
          height: 6px;
          background: @app-color;
          border-radius: 6px;
        }
        &:after {
          content: ' ';
          display: block;
          clear: both;
        }
        .payment-row {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          &.detail {
            padding-top: 10px;
          }
          .title {
            font-size: 14px;
            margin-top: -3px;
          }
          .tag {
            transform: scale(0.9);
            transform-origin: left;
            line-height: 19px;
          }
          .time {
            .font-light;
            color: @app-body-color;
            font-size: 14px;
            font-weight: 300;
            margin-top: -3px;
          }
          .detail {
            .font-light;
            font-size: 12px;
            font-weight: 300;
            color: @app-blue-color;
            cursor: pointer;
          }
          .price {
            .font-medium;
            font-size: 16px;
            font-weight: 500;
            color: @app-black-color;
          }
        }
        .info-list {
          background: #f7f8fc;
          border-radius: 4px;
          margin-top: 20px;
          .info-item {
            padding: 12px 24px 0;
            height: 70px;
            align-items: center;
            border-bottom: 1px solid #eeeff0;
            &:last-child {
              border-bottom: 0 solid #eeeff0;
            }
            .info {
              flex: 1;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              .title {
                font-size: 14px;
                font-weight: 400;
              }
              .desc {
                .font-light;
                padding-top: 6px;
                font-size: 12px;
                font-weight: 300;
                color: @app-body-color;
              }
              .shipping-fee {
                text-decoration: line-through;
              }
              .detail {
                .font-light;
                font-size: 12px;
                font-weight: 300;
                color: @app-blue-color;
              }
            }
            .price {
              .font-medium;
              font-size: 14px;
              font-weight: 500;
              color: #262626;
            }
          }
        }
      }
    }
  }
}
.pop-detail-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.pop-box-item {
  &:last-child,
  &.storing {
    .row {
      border-bottom: 0 solid #eeeff0;
    }
  }
  .row {
    margin: 0;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eeeff0;
    &:last-child {
      .content {
        border-bottom: 0 solid #eeeff0;
      }
    }
    &.total {
      .font-regular;
      justify-content: flex-end;
      font-size: 14px;
      font-weight: 400;
      color: @app-black-color;
    }
    .num {
      .font-regular;
      width: 56px;
      font-size: 14px;
      font-weight: 400;
      color: #262626;
    }
    .content {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eeeff0;
      .content-row {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        line-height: 16px;
        .status-info {
          padding-top: 10px;
        }
        .tip,
        .status-lable,
        .tip-right {
          .font-light;
          font-size: 12px;
          font-weight: 300;
          color: @app-body-color;
        }
        .tip-right {
          text-align: right;
        }
        .status-lable {
          text-align: right;
        }
        .number {
          .font-regular;
          font-size: 14px;
          font-weight: 400;
          padding-top: 6px;
          display: flex;
          align-items: center;
        }
        .day {
          .font-regular;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: @app-color;
        }
        .status {
          .font-regular;
          font-size: 14px;
          font-weight: 400;
          color: @app-black-color;
        }
        .btn {
          border-radius: 18px;
          .d-cion {
            font-size: 13px;
            margin-right: 6px;
          }
        }
        .fee,
        .weight {
          .font-regular;
          font-size: 14px;
          font-weight: 400;
          margin-left: 40px;
          text-align: right;
          color: @app-black-color;
        }
        .weight {
          padding-top: 6px;
        }
      }
    }
  }
}
</style>
